/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioTipoRegimenVistaProps } from '../interfaces';

const FormularioTipoRegimenVista: React.FunctionComponent<IFormularioTipoRegimenVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tipoRegimen,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tipoRegimen.agregarTipoRegimen'
                                : 'tipoRegimen.modificarTipoRegimen'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoRegimen.codigoTipoRegimen" display="inline" />}
                        name="CodigoTipoRegimen"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={tipoRegimen.CodigoTipoRegimen}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoRegimen.nombreTipoRegimen" display="inline" />}
                        name="NombreTipoRegimen"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoRegimen.NombreTipoRegimen}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={tipoRegimen.EstadoTipoRegimen} onChange={cambiarInfoFomulario} />}
                        label={<Texto id="tipoRegimen.estadoTipoRegimen" display="inline" />}
                        name="EstadoTipoRegimen"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioTipoRegimenVista;
